extraDocuments.classy.controller({
    name: 'ExtraDocumentsController',
    inject: ['$scope', 'DocumentsModelService', '$rootScope', 'standardCudArrayFactory', 'authServiceFactory'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.arrayCud = new this.standardCudArrayFactory(this.DocumentsModelService,
           this.authServiceFactory.getAuth().schoolID, this.DocumentsModelService.get(), this, ['items']);
        this.$.DocumentsModelService = this.DocumentsModelService;
        this.$rootScope.model = this.DocumentsModelService;
    },
    submit: function(scope, instance, form) 
    {
        var parent = this;
        if (form.$valid) {
            this.$.arrayCud.startSaveProcess(scope, instance, form).then(function(results) {
                parent.$.items = results.data;
            });
        }
        else {
            instance.stop(-1);
        }
    },
    del: function(index)
    {
        if (typeof this.$.items[index].recordID !== 'undefined')
        {
            //this.$.items[index].showDeleted = 1;
            this.$.items[index].InUse = 0;
            this.$.arrayCud.toggleEditItem(index);
        }
        else
        {
            this.$.arrayCud.editItem.pop();
            this.$.items.pop();
        }
    }

});

